(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (() => {
    const initializeNavigation = () => {
      const nav = document.querySelector('.nb-primary-nav');
      if (!nav) return;
      const header = nav.closest('.section-header');
      if (!header) return;
      header.nbNavigationCleanup?.();
      const links = [...header.querySelectorAll('[data-nb-nav-link]')];
      const homepage = nav.dataset.nbHomepage === 'true';
      const scents = homepage ? document.getElementById('naturalistic-scents') : null;
      let frame = 0;
      let headerHeight = 0;
      const setCurrent = (key, kind = 'page') => {
        links.forEach((link) => {
          if (link.dataset.nbNavLink === key) link.setAttribute('aria-current', kind);
          else link.removeAttribute('aria-current');
        });
      };
      const syncLocationCurrent = () => {
        if (!homepage) return;
        setCurrent(location.hash === '#naturalistic-scents' ? 'scents' : nav.dataset.nbCurrentNav, 'location');
      };
      const measureHeader = () => {
        const height = Math.ceil(header.getBoundingClientRect().height);
        if (height !== headerHeight) {
          headerHeight = height;
          document.documentElement.style.setProperty('--nb-navigation-header-height', `${height}px`);
        }
      };
      const update = () => {
        frame = 0;
        measureHeader();
      };
      const schedule = () => {
        if (!frame) frame = requestAnimationFrame(update);
      };
      const onLocationChange = () => {
        syncLocationCurrent();
        schedule();
      };
      const onClick = (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest('a[href]');
        if (!link) return;
        if (header.contains(link) && link.dataset.nbNavLink) setCurrent(link.dataset.nbNavLink);
        const url = new URL(link.href, location.href);
        if (!scents || url.origin !== location.origin || url.pathname !== location.pathname || url.hash !== '#naturalistic-scents') return;
        setCurrent('scents', 'location');
        measureHeader();
        const drawer = link.closest('header-drawer');
        if (drawer && typeof drawer.closeMenuDrawer === 'function') {
          const toggle = drawer.querySelector('summary');
          drawer.closeMenuDrawer(event, toggle);
          toggle.setAttribute('aria-expanded', 'false');
        }
      };
      const alignInitialHash = () => {
        measureHeader();
        if (scents && location.hash === '#naturalistic-scents') scents.scrollIntoView({ block: 'start', behavior: 'auto' });
        schedule();
      };
      const observer = new ResizeObserver(schedule);
      observer.observe(header);
      document.addEventListener('click', onClick);
      window.addEventListener('resize', schedule);
      window.addEventListener('hashchange', onLocationChange);
      window.addEventListener('pageshow', onLocationChange);
      header.nbNavigationCleanup = () => {
        observer.disconnect();
        cancelAnimationFrame(frame);
        document.removeEventListener('click', onClick);
        window.removeEventListener('resize', schedule);
        window.removeEventListener('hashchange', onLocationChange);
        window.removeEventListener('pageshow', onLocationChange);
      };
      setCurrent(nav.dataset.nbCurrentNav, homepage ? 'location' : 'page');
      syncLocationCurrent();
      alignInitialHash();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeNavigation, { once: true });
    else initializeNavigation();
    document.addEventListener('shopify:section:load', initializeNavigation);
    document.addEventListener('shopify:section:unload', (event) => event.target.nbNavigationCleanup?.());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naturalistic-compact-footer"] && !Shopify.designMode) return;
  try {
    
const footerGroups = document.querySelectorAll('.nb-compact-footer__group');
const footerMobile = window.matchMedia('(max-width:749px)');
const resetFooter = () => footerGroups.forEach(group => {group.open = !footerMobile.matches;});
resetFooter();
footerMobile.addEventListener('change', resetFooter);

  } catch(e) { console.error(e); }
})();
})();
